
import React from "react";
import { useNavigate } from "react-router-dom";

interface LogoProps {
  isAuthenticated: boolean;
}

export function Logo({ isAuthenticated }: LogoProps) {
  const navigate = useNavigate();

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(isAuthenticated ? "/dashboard" : "/");
  };

  return (
    <a href="#" onClick={handleLogoClick} className="flex items-center gap-2 mr-4">
      <img
        src="/lovable-uploads/b39387ca-08fc-4e1c-a0f7-79c2fa0f4845.png"
        alt="Subtrackr Logo"
        className="h-8"
      />
    </a>
  );
}
